import { Transaction } from '../../types/Transaction';
import { TransactionsFilterProperties } from './TransactionsFilterProperties';
import { TransactionPropertiesGroup } from './TransactionPropertiesGroup';

export function getTransactionPropertiesGroup(
  transaction: Transaction,
  group: TransactionPropertiesGroup,
): TransactionsFilterProperties {
  if (group === TransactionPropertiesGroup.Left) {
    // Checkout is approved when status is no longer pending_checkout
    const isApproved = transaction.status !== 'pending_checkout';
    return {
      startedAt: transaction.leftAt,
      approvedAt: transaction.leftApprovedAt,
      approvedBy: transaction.leftApprovedBy,
      isApproved,
    };
  } else {
    // Return is approved when status is completed
    const isApproved = transaction.status === 'completed';
    return {
      startedAt: transaction.returnedAt,
      approvedAt: transaction.returnApprovedAt,
      approvedBy: transaction.returnApprovedBy,
      isApproved,
    };
  }
}
